import React from "react";
import Header from "../../components/common/Header";
import Button from "../../components/ui/Button";
// import Header from "../../components/common/Header"; // Make sure path is correct

const HeroSection = () => {
  return (
    <div className="relative min-h-[70vh] md:min-h-screen flex flex-col font-sans overflow-hidden">
      {/* Background Image Container */}
      <div
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/Biospecimens.png')`,
        }}
      >
        {/* Overlays */}
        <div className="absolute inset-0 bg-blue-900/60 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/40 via-transparent to-transparent"></div>
      </div>

      {/* Navigation */}
      <Header />

      {/* Hero Content */}
      <main className="relative z-10 flex-grow flex flex-col items-center justify-start md:justify-center px-4 text-center mt-[50px] ">
        <h1 className="text-white text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px]  font-bold max-w-[1601px] leading-tight">
          Diagnostic Excellence. <br /> Research-Grade Biospecimens.
        </h1>

        <p className="text-white/90 mt-6 max-w-[1601px] text-sm md:text-[24px] leading-relaxed">
          Power your research with ethically sourced, clinically annotated human
          biospecimens—delivered through diagnostic expertise, supporting both
          retrospective collections and custom prospective studies with
          uncompromised quality and data integrity.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Button
            to="/rfq"
            className="bg-white text-[#183076] px-8 py-3 rounded-full font-bold hover:bg-[transparent] hover:text-[#FFFFFF] border-2 transition shadow-xl"
          >
            Book Now
          </Button>
          {/* <Button
            to="/biospecimens-category"
            className="border-2 border-white text-white px-8 py-3 rounded-full font-bold hover:bg-white hover:text-[#183076] transition"
          >
            Explore Now
          </Button> */}
        </div>
      </main>

      {/* --- CURVE SECTION START --- */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] z-20">
        <svg
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          className="relative block w-[calc(100%+1.3px)] h-[60px] md:h-[100px]"
          fill="#ffffff"
        >
          <path d="M0,0 C480,120 720,120 1200,0 L1200,120 L0,120 Z"></path>
        </svg>
      </div>
      {/* --- CURVE SECTION END --- */}
    </div>
  );
};

export default HeroSection;
